import React from "react";
// ANT DESIGN COMPONENTS
import { Switch } from "antd";
// INTERFACES
import { FormSwitchActiveInactiveInterface } from "../../../interfaces/Global.interface";

function FormSwitchActiveInactive({
  inputValue,
  inputOnChange,
  inputLabelName,
  inputVariableName,
}: FormSwitchActiveInactiveInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span>{inputLabelName}</span>
        </div>
        <div className="generalStyles__width100">
          <Switch
            onChange={(e) => {
              inputOnChange(e, inputVariableName);
            }}
            checked={inputValue}
          />
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}

export default FormSwitchActiveInactive;
